import { CLOSE } from 'types/session';
import Request from './Request';

export default function ReportSessions() {
	return <Request status={[CLOSE]} mode="report" />;
}
